import React from "react";

const Thermometer = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_1632_224" x="0" y="0" width="25" height="25">
        <rect width="25" height="25" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1632_224)">
        <path
          d="M12.4998 21.875C11.1453 21.875 9.99072 21.3977 9.03604 20.443C8.08135 19.4883 7.604 18.3337 7.604 16.9792C7.604 16.1331 7.80366 15.3444 8.20296 14.6129C8.60227 13.8814 9.15493 13.2812 9.86096 12.8125V5.76388C9.86096 5.03086 10.1171 4.40779 10.6294 3.89466C11.1418 3.38155 11.7639 3.125 12.4957 3.125C13.2276 3.125 13.8511 3.38155 14.3661 3.89466C14.8812 4.40779 15.1387 5.03086 15.1387 5.76388V12.8125C15.8447 13.2812 16.3974 13.8814 16.7967 14.6129C17.196 15.3444 17.3957 16.1331 17.3957 16.9792C17.3957 18.3337 16.9183 19.4883 15.9636 20.443C15.009 21.3977 13.8544 21.875 12.4998 21.875ZM11.5971 10.2604H13.4026V5.76388C13.4026 5.50808 13.3161 5.29367 13.1431 5.12065C12.97 4.94761 12.7556 4.86109 12.4998 4.86109C12.2441 4.86109 12.0296 4.94761 11.8566 5.12065C11.6836 5.29367 11.5971 5.50808 11.5971 5.76388V10.2604Z"
          fill="#56CCF2"
        />
      </g>
    </svg>
  );
};

export default Thermometer;
